import { Box, Card, Table, TableBody, TableCell, TableContainer, TableRow, Typography, useTheme } from '@mui/material'
import noExamsImg from '../../../assets/noexams.svg'
import TableHeader from '../../common/TableHeader'
import React, { useCallback, useEffect, useState } from 'react'
import LineGraph from '../../common/LineBarGraph'
import api from '../../../service/api'
import TryAgainMessageBlock from '../../common/TryAgainMessageBlock'
import DataLoadingSpinner from '../../common/DataLoadingSpinner'
import { Link } from 'react-router-dom'

const columns = [
    { name: "Faculty", padding: "10px 20px 10px 40px" },
    { name: "Department", padding: "10px 20px" },
    { name: "Exams", padding: "10px 20px", align: "center" },
    { name: "Participation", align: "center", padding: "10px 40px 10px 20px" },
]

const ExamsLast30Details = () => {

    const [tableData, setTableData] = useState( [] )
    const [graphData, setGraphData] = useState( [] )
    const [loading, setLoading] = useState( true )
    const [error, setError] = useState( null )

    const { table } = useTheme()

    const getData = useCallback( async () => {
        setLoading( true )
        try {
            const { data: { data: { facultyStats } } } = await api.audit.getExamsStats( { month: "last30days" } )
            const { data: { data: graphData } } = await api.audit.getExamGraphData()

            setError( null )
            setGraphData( graphData )
            setTableData( facultyStats )
        } catch ( err ) {
            setError( err?.response?.data?.message || err?.response?.data || "Something went wrong while getting the exams stats." )
        } finally {
            setLoading( false )
        }
    }, [] )

    useEffect( () => {
        getData()
    }, [getData] )

    return (
        <Card sx={{ flexShrink: 0, minHeight: "400px", display: "flex", flexDirection: "column" }}>
            {!loading && tableData.length > 0 && <Box padding="10px" flexGrow={1} overflow="auto" alignItems="stretch" display="grid" gap='20px' gridTemplateColumns={{ md: "1fr 1fr", xs: "1fr" }}>
                <Box display="flex" maxHeight="400px" overflow="auto" flexGrow={1} flexDirection="column">
                    <Typography padding={{ xs: "10px", md: "20px" }} fontSize="16px" fontWeight="bold" color="primaryDark.main">Last 30 days exams stats</Typography>
                    <TableContainer sx={{ overflow: "auto" }} className='slim-custom-scrollbar' >
                        <Table stickyHeader>
                            <TableHeader fontSize="14px" columns={columns} />
                            <TableBody>
                                {tableData.map( ( row, index ) => (
                                    <TableRow className='table-row' key={index}>
                                        <TableCell sx={{ fontSize: "12px", color: table.color, padding: columns[0].padding || "10px 20px" }}>
                                            <Typography sx={{ fontSize: "12px", cursor: "pointer", '&:hover': { textDecoration: "underline" } }} ><Link className='default-link' to={`/${window.location.pathname?.includes( 'admin' ) ? "admin" : "audit"}/faculty/${row.created_by}?legacy=${row.legacy_system_data}`} >{row?.faculty_name || row?.created_by}</Link></Typography>
                                        </TableCell>
                                        <TableCell sx={{ fontSize: "12px", color: table.color, padding: columns[1].padding || "10px 20px", textTransform: "capitalize" }} align={columns[1].align || "left"}>{row.institute || "ADM"} - {row.department?.toUpperCase() || "ASSESSEMENTS"}</TableCell>
                                        <TableCell align={columns[2].align || "left"} sx={{ fontSize: "12px", padding: "10px 20px", color: table.color }}>{row['count']}</TableCell>
                                        <TableCell align={columns[3].align || "left"} sx={{ fontSize: "12px", color: table.color, padding: columns[2].padding || "10px 20px" }}>{row?.attempts}</TableCell>
                                    </TableRow>
                                ) )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

                <LineGraph barColor='#ffaa00' lineColor='#642547' graphTitle="Last 30 days activities" showMenuBar={false} barLegend='Exam attempts' yAxisName="Exams" xAxisName="Date" y2AxisName="Attempts" lineLegend='Exams created' barValuesKey="attempts" barData={graphData} dateformat={"%Y-%m-%d"} xAxisValuesKey={'date'} lineValuesKey={'exams'} lineData={graphData} />
            </Box >}
            {!loading && !error &&
                tableData.length === 0 && <Box flexGrow={1} flexDirection="column" padding="20px" display="flex" alignItems="center" justifyContent="center" gap="20px">
                    <img src={noExamsImg} height="120px" alt="No exams in last 30 days" />
                    <Typography textAlign="center" variant='subtitle2'>No exams were created in last 30 days</Typography>
                </Box>
            }
            {loading && !error && <Box display="flex" flexGrow={1} justifyContent="center">
                <DataLoadingSpinner waitingMessage="Loading last 30 days exams activities..." />
            </Box>}
            {error && <Box display="flex" flexGrow={1} justifyContent="center">
                <TryAgainMessageBlock err={error} getData={getData} loading={loading} />
            </Box>}
        </Card >
    )
}

export default ExamsLast30Details
